<div class="col-12 col-sm-12 col-md-12 col-lg-12 boxstyle">
        <div class="row pb-2">
            <label class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 bold fs-20 txt-black1">Reports</label>
        </div>
        <div class="row">
            <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                <div class="report-content">
                    <div class="border-down">
                        <label class="bold fs-16 red5">Select a Report</label>
                    </div>
                    <div class="pt-2 fs-16" *ngIf="(leadType=='Office Admin Staff' && (commitionToOfLead=='Broker' || commitionToOfLead=='Agency'))">
                        <a class="cp" (click)="goToReportDetails('MGA OVR Commission Statement')">MGA OVR Commission Statement</a>
                    </div>
                    <div class="pt-2 fs-16" *ngIf="(leadType=='Office Admin Staff' && commitionToOfLead=='MGA')">
                        <a class="cp" (click)="goToReportDetails('MGA Commission')">MGA Commission</a>
                    </div>
                    <div class="pt-2 fs-16" *ngIf="(leadType=='Office Admin Staff' && (commitionToOfLead=='Broker' || commitionToOfLead=='Agency')) || (leadType=='Office Admin Staff' && commitionToOfLead=='MGA')">
                        <a class="cp" (click)="goToReportDetails('MGA Sales by Broker')">MGA Sales by Broker</a>
                    </div>
                </div>
            </div>
        </div>

</div>